// extracted by mini-css-extract-plugin
module.exports = {"paymentCheckout":"confirm_paymentCheckout__3LaFw","viewCart":"confirm_viewCart__247vp","method":"confirm_method__2zjVW","addName":"confirm_addName__2G2Mo"};